/* TypeScript file generated from Touchable.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as TouchableJS from './Touchable.res.js';

import type {Button_pressEvent as ReactAria_Button_pressEvent} from '../../src/externals/ReactAria.gen';

import type {Button_props as ReactAria_Button_props} from '../../src/externals/ReactAria.gen';

import type {Style_t as StyleX_Style_t} from '../../src/externals/StyleX.gen';

import type {navigateOptions as Navigation_navigateOptions} from './Navigation.gen';

export type props<children,ariaProps,disabled,excludeFromTabOrder,wrap,grow,style,href,routerOptions,onPress,ref> = {
  readonly children: children; 
  readonly ariaProps?: ariaProps; 
  readonly disabled?: disabled; 
  readonly excludeFromTabOrder?: excludeFromTabOrder; 
  readonly wrap?: wrap; 
  readonly grow?: grow; 
  readonly style?: style; 
  readonly href?: href; 
  readonly routerOptions?: routerOptions; 
  readonly onPress?: onPress; 
  readonly ref?: ref
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly ariaProps?: ReactAria_Button_props; 
  readonly disabled?: boolean; 
  readonly excludeFromTabOrder?: boolean; 
  readonly wrap?: boolean; 
  readonly grow?: boolean; 
  readonly style?: StyleX_Style_t; 
  readonly href?: string; 
  readonly routerOptions?: Navigation_navigateOptions; 
  readonly onPress?: (_1:ReactAria_Button_pressEvent) => void; 
  readonly ref?: any
}> = TouchableJS.make as any;
